module.exports = __webpack_public_path__ + "images/account_close_btn.png";